import { render, staticRenderFns } from "./Findings.vue?vue&type=template&id=117a34eb&"
import script from "./Findings.vue?vue&type=script&lang=js&"
export * from "./Findings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports